module.exports = __webpack_public_path__ + "static/media/6_Prepare-Existing-Transformer-Cable-ConnectorLabel3.993c4a56.svg";